import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$destination/$interest')({
  beforeLoad: () => {
    throw redirect({ to: '/' });
  },
});
